import { Box } from 'components/Box'
import { Text } from 'components/Text'
import { styled } from 'stitches.config'

export const StepRoot = styled('div', {
  '.step-title': {
    color: '$$titleColor',
  },

  variants: {
    inactive: {
      false: {
        $$titleColor: '$colors$primary-800',
        $$valuesColor: '$colors$tertiary-900',
      },
      true: {
        $$titleColor: '$colors$tertiary-200',
        $$valuesColor: '$colors$tertiary-200',
      },
    },
  },

  defaultVariants: {
    inactive: false,
  },
})

export const StepInfo = styled('div', {
  color: '$$valuesColor',

  '&&': {
    alignItems: 'flex-start',
  },

  [`& div`]: {
    display: 'flex',
    flexDirection: 'column',

    '& a': {
      textDecoration: 'underline',
    },
  },
})
